export default {
  featureFlags: (state) => state.featureFlags,
  isFeatureFlagEnabled: (state, getters) => (key) => {
    return getters.featureFlagsLoaded && !!state.featureFlags[key]
  },
  featureFlagsLoaded: (state) => state.loaded,
}
